import { useVoterData, useSearch, SearchBars, cardKeys } from "../utils/voterUtils";

export default function VoterSearch() {
  const data = useVoterData();
  const {
    searchName, setSearchName,
    searchRname, setSearchRname,
    searchVid, setSearchVid,
    hasQuery, filtered,
  } = useSearch(data);

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif" }}>
      {/* Banner */}
      <div style={{ lineHeight: 0 }}>
        <img
          src="/banner.jfif"
          alt="Banner"
          style={{ width: "100%", display: "block", maxHeight: "220px", objectFit: "cover" }}
        />
      </div>

      <div className="container py-4">
        <h2 className="text-center mb-1 text-primary">🗳️ मतदाता खोज</h2>
        <p className="text-center text-muted small mb-4">
          Search for any voter by name, relative name, or voter ID
        </p>

        <SearchBars
          searchName={searchName} setSearchName={setSearchName}
          searchRname={searchRname} setSearchRname={setSearchRname}
          searchVid={searchVid} setSearchVid={setSearchVid}
        />

        <p className="text-muted small mb-4" style={{ fontSize: "12px" }}>
          💡 Results match from the <strong>start</strong> of each field. Fill one or more boxes to filter.
        </p>

        {hasQuery && (
          <p className="text-secondary small mb-3">
            Showing <strong>{Math.min(filtered.length, 200)}</strong>
            {filtered.length > 200 ? ` of ${filtered.length}` : ""} result(s)
          </p>
        )}

        <div className="row">
          {filtered.slice(0, 200).map((row, i) => {
            const keys = cardKeys(row);
            return (
              <div key={i} className="col-md-6 col-lg-4 mb-4">
                <div className="card shadow border h-100">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <strong>Voter Card</strong>
                    <span className="badge bg-secondary">{row.VOTER_ID || row.VOTERID || row.VID}</span>
                  </div>
                  <div className="card-body">
                    <div className="d-flex">
                      <div
                        style={{
                          width: "90px", height: "110px",
                          border: "1px dashed gray",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          fontSize: "12px", marginRight: "12px", flexShrink: 0,
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        Photo
                      </div>
                      <div className="row" style={{ flex: 1 }}>
                        {keys.map((key, idx) => {
                          let label = key;
                          const value = row[key] || "-";
                          if (key === "VNAME") label = "Name";
                          if (key === "RNAME") label = "Relative Name";
                          if (key === "VID")   label = "Voter Id";
                          return (
                            <div key={idx} className="col-6 mb-2">
                              <div style={{ fontSize: "13px" }}>
                                <strong>{label}:</strong>
                                <div style={{ marginTop: "2px" }}>{value}</div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer text-center text-muted small">
                    Sabka Saath, Sabka Vikas, Sabka Vishwas
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
